/**
 * @fileoverview GET handler for the "/custom_objects/user_linked_custom_object_types" endpoint.
 * Returns the custom object types that have at least one user relationship defined.
 */
import fetch from "@lib/fetch";

import { buildCustomObjectsQueryParams } from "../customObjectsShared/buildQueryParams";
import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { customObjectsUserLinkedCustomObjectTypes } from "./constants";
import type {
  GetCustomObjectsUserLinkedCustomObjectTypesParams,
  GetCustomObjectsUserLinkedCustomObjectTypesResult,
} from "./types";
import { isGetCustomObjectsUserLinkedCustomObjectTypesResult } from "./validators";

export const getCustomObjectsUserLinkedCustomObjectTypes = reactQueryFetcherAdapter(
  customObjectsUserLinkedCustomObjectTypes,
  (
    signal: AbortSignal,
    params: GetCustomObjectsUserLinkedCustomObjectTypesParams
  ): Promise<GetCustomObjectsUserLinkedCustomObjectTypesResult> => {
    return fetch(
      "/custom_objects/user_linked_custom_object_types",
      "GET",
      buildCustomObjectsQueryParams(params),
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isGetCustomObjectsUserLinkedCustomObjectTypesResult
);
